import axios from "axios";
import { Cookies } from "../constants/Cookies";
import { util } from "../config/util";
import GlobalEnvironments from "../modules/globalEnvironment/GlobalEnvironment";

/**
 * 행동 이벤트 기록 (계측 1차). 서버 event_log 테이블에 1건씩 남긴다.
 * - 로그인(authKey 쿠키)이 없으면 보내지 않는다.
 * - 응답·오류는 무시한다 (기록 실패가 화면 흐름에 영향을 주면 안 됨).
 */
export const logEvent = (
  event: string,
  source: string = "",
  meta: Record<string, any> = {}
) => {
  try {
    const key = util.getCookie(Cookies.authKey);
    if (!key) return;
    axios
      .post(
        `${GlobalEnvironments.getApiUrl()}event_log/`,
        { event, source, meta },
        { headers: { Authorization: `Token ${key}` } }
      )
      .catch(() => {});
  } catch (e) {
    // 기록 실패는 무시
  }
};

// SPA 안에서의 직전 경로 (결제 화면 진입 경로 파악용).
// /payment 는 /subscription 으로 리다이렉트만 하는 경로라 직전 경로로 치지 않는다.
const TRANSPARENT_PATHS = ["/payment"];
let currentPath = "";
let previousPath = "";

export const trackRoute = (pathname: string) => {
  if (!pathname || TRANSPARENT_PATHS.includes(pathname) || pathname === currentPath) return;
  previousPath = currentPath;
  currentPath = pathname;
};

export const getPreviousPath = () => previousPath;
